<template>
  <v-container>
    <v-row>
      <v-col>
        <p class="display-1">Forside</p>
      </v-col>
    </v-row>
    <v-row align="stretch" justify="center">
      <v-col>
        <v-row align="center" justify="center"
          ><v-col>
            <p>
              Dette er en side under udvikling. Du vil kunne opleve fejl.
            </p>
          </v-col></v-row
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: "home"
};
</script>
